import React from 'react'

import { bool, string, number, oneOf, shape } from 'prop-types'

import { useIs3dPrintModel, useRole } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'

import { getDate } from 'Utils/FormatDate'

import UseCaseInfoItem from './Components/UseCaseInfoItem/UseCaseInfoItem'
import UseCaseUserInfo from './Components/UseCaseUserInfo/UseCaseUserInfo'
import { getTechnologyLabel, getMaterialLabel, getPrintTimeLabel } from '../../../../Utils/Data'

function UseCaseInfo({
  username,
  createdAt,
  description = null,
  technology = null,
  printerType = null,
  slicesDetails = null,
  avatarUrl = null,
  material = null,
  printSuccess = null,
  printTime = null,
  usedSupport = false,
  canDownloadSlicerFile = true,
  isOwner = false,
}) {
  const is3dPrintModel = useIs3dPrintModel()
  const role = useRole()
  const printerTypeLabel = printerType?.name || null
  const shouldShowPrintResult = printSuccess && !(role === 'seller' && isOwner)

  return (
    <div className="use-case-info">
      <div className="use-case-info__list">
        {is3dPrintModel && (
          <>
            <UseCaseInfoItem title="Printer used" value={printerTypeLabel} highlightValue />
            <UseCaseInfoItem title="Material" value={getMaterialLabel(material)} highlightValue />
            {shouldShowPrintResult && (
              <UseCaseInfoItem title="How did your print turned out?" value={printSuccess} highlightValue />
            )}
            <UseCaseInfoItem
              title="Slicer details"
              value={slicesDetails}
              highlightValue
              showPendingLink
              canDownload={canDownloadSlicerFile}
            />
            <UseCaseInfoItem title="Printing technology" value={getTechnologyLabel(technology)} highlightValue />
            <UseCaseInfoItem title="Print time" value={getPrintTimeLabel(printTime)} highlightValue />
            {usedSupport && <UseCaseInfoItem title="Supports used?" value="Yes" highlightValue />}
          </>
        )}
        <UseCaseUserInfo username={username} avatarUrl={avatarUrl} />
        <UseCaseInfoItem title="Added" value={getDate(createdAt)} />
      </div>
      <div className="use-case-info__description">
        {description || 'No description provided'}
      </div>
    </div>
  )
}

UseCaseInfo.propTypes = {
  username: string.isRequired,
  createdAt: string.isRequired,
  description: string,
  technology: oneOf(['fdm', 'sla', 'sls', 'poly_jet', 'metal_printing', 'metal_jet', 'other', null]),
  printerType: shape({
    id: number,
    name: string,
    hidden: bool,
  }),
  slicesDetails: string,
  avatarUrl: string,
  material: string,
  printSuccess: string,
  printTime: string,
  usedSupport: bool,
  canDownloadSlicerFile: bool,
  isOwner: bool,
}

export default UseCaseInfo
